module.exports = __webpack_public_path__ + "static/media/HP_card_lakeside_at_town.69724d87.jpg";